import { LS_CRUISE_SECURITY_REMINDER_DISMISSED_KEY } from '@share/constants';

export const shouldDisplayCruiseSecurityReminder = (): boolean => {
  try {
    return !localStorage.getItem(LS_CRUISE_SECURITY_REMINDER_DISMISSED_KEY);
  } catch (error) {
    console.error('Unable to read cruise security reminder preference', error);
    return true;
  }
};

export const disableCruiseSecurityReminder = (): void => {
  try {
    localStorage.setItem(LS_CRUISE_SECURITY_REMINDER_DISMISSED_KEY, new Date().getTime().toString());
  } catch (error) {
    console.error('Unable to save cruise security reminder preference', error);
  }
};
